import { render, staticRenderFns } from "./CubesTween.vue?vue&type=template&id=1ecd379e&scoped=true&"
import script from "./CubesTween.vue?vue&type=script&lang=js&"
export * from "./CubesTween.vue?vue&type=script&lang=js&"
import style0 from "./CubesTween.vue?vue&type=style&index=0&id=1ecd379e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd379e",
  null
  
)

export default component.exports